import { dsColorNew } from "@palette"

// The list fields of the wizard (seasons, durations, lead times): a light well holding the ranges
// already chosen as soft-blue chips, the quiet preset chips that offer more, and the add row.
export const rangeWellSx = {
	display: 'flex', flexDirection: 'column', gap: 1.25,
	p: 1.5,
	bgcolor: dsColorNew.tableRowAlt,
	border: `1px solid ${dsColorNew.grayBorder}`,
	borderRadius: '10px',
}

// A range in the list. Roboto's figures are all the same width, so a column of ranges lines up.
export const rangeChipSx = {
	height: 30,
	bgcolor: dsColorNew.pillActiveBg,
	color: dsColorNew.appBlue,
	'& .MuiChip-label': { px: 1.25 },
	'& .MuiChip-deleteIcon': {
		color: dsColorNew.appBlue,
		opacity: 0.6,
		'&:hover': { color: dsColorNew.appBlueHover, opacity: 1 },
	},
}
export const rangeChipFiguresSx = { fontFamily: 'inherit', fontWeight: 600, fontSize: 13 }
export const rangeChipArrowSx = { color: dsColorNew.appBlue, mx: 0.5, opacity: 0.6 }
export const rangeChipUnitSx = { ml: 0.5, color: dsColorNew.textMuted, fontFamily: 'inherit', fontWeight: 500, fontSize: 12 }

// The line between the chips and the add row
export const rangeAddRowSx = isEmpty => ({
	pt: !isEmpty ? 1.25 : 0,
	borderTop: !isEmpty ? `1px dashed ${dsColorNew.grayBorder}` : 'none',
})
